import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Define the initial state
interface PublishMenuState {
    isPublished: boolean;
}

// Load state from localStorage
const loadState = (): PublishMenuState | undefined => {
    try {
        const serializedState = localStorage.getItem("publishMenuState");
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        console.error("Failed to load state from localStorage:", err);
        return undefined;
    }
};

// Save state to localStorage
const saveState = (state: PublishMenuState) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem("publishMenuState", serializedState);
    } catch (err) {
        console.error("Failed to save state to localStorage:", err);
    }
};

// Initialize state from localStorage or use default initial state
const initialState: PublishMenuState = loadState() || {
    isPublished: false,
};

// Create the slice
const publishMenuSlice = createSlice({
    name: "publishMenu",
    initialState,
    reducers: {
        setIsPublished(state, action: PayloadAction<boolean>) {
            state.isPublished = action.payload;
            saveState(state); // Save state to localStorage
        },
        resetPublishMenu(state) {
            state.isPublished = false;
            saveState(state); // Save state to localStorage
        },
    },
});

// Export actions
export const { setIsPublished, resetPublishMenu } = publishMenuSlice.actions;

// Export reducer
export default publishMenuSlice.reducer;